var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10518_26077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6108 3.27376C29.4559 3.13997 29.2674 3.051 29.0656 3.01641C28.8638 2.98183 28.6565 3.00296 28.4658 3.07751L3.1333 12.9913C2.77428 13.1309 2.47033 13.3833 2.26721 13.7106C2.06409 14.0379 1.97278 14.4224 2.00705 14.806C2.04131 15.1897 2.19929 15.5519 2.4572 15.838C2.7151 16.1241 3.05898 16.3187 3.43705 16.3925L10.0008 17.6813V25C9.99951 25.3987 10.118 25.7885 10.3409 26.119C10.5637 26.4496 10.8807 26.7055 11.2508 26.8538C11.6203 27.0046 12.0266 27.0409 12.417 26.9577C12.8073 26.8746 13.1636 26.6759 13.4396 26.3875L16.6046 23.105L21.6258 27.5C21.9881 27.8213 22.4553 27.9992 22.9396 28C23.1518 27.9998 23.3626 27.9665 23.5646 27.9013C23.8945 27.7966 24.1912 27.6073 24.4252 27.3522C24.6593 27.0971 24.8224 26.7852 24.8983 26.4475L29.9721 4.37501C30.0174 4.17595 30.0078 3.96829 29.9442 3.77429C29.8805 3.58029 29.7653 3.40727 29.6108 3.27376ZM22.9421 26L12.6071 16.9375L27.4821 6.27626L22.9421 26Z",
    fill: "#D5D6D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10518_26077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.9b4233b78c5deec900f2a7248028f3f2.svg";
export { ForwardRef as ReactComponent };